/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import React from "react";
import { TextField } from "office-ui-fabric-react/lib/TextField";
import FormikErrorMessage from "../FormikErrorMessage/FormikErrorMessage";
import { ColumnContent } from "../Layout/Layout";

/**
 * Formik Text Field HoC
 */
const FormikTextField = ({
  field, // { name, value, onChange, onBlur}
  form, // { touched, errors, values }, also values , setXXX, handleXXX< dirty, isValid, status, etc
  styles,
  ...props
}): React.ReactElement => (
  <ColumnContent>
    <TextField
      disabled={props.isDisabled}
      onChange={[field.onChange]}
      styles={styles}
      {...field}
      {...props}
    />
    <FormikErrorMessage name={field.name} />
  </ColumnContent>
);

export default FormikTextField;
